const rebuildSubjectsArray = (phases: any) => {
  // phases.forEach((phase: any) => {
  // phase.subjects.forEach((subject: any) => {
  //   subject.chapterCount = 0;
  // });
  // });

  phases.forEach((phase: any) => {
    phase.subjects = [];
    phase.weeks.forEach((week: any) => {
      week.subjects.forEach((subject: any) => {
        let index = getIndex(phase, subject.name);
        if (index === -1) {
          phase.subjects.push({
            name: subject.name,
            id: subject.id,
            chapterCount: subject.chapters.length,
          });
        } else {
          phase.subjects[index].chapterCount += subject.chapters.length;
        }
      });
    });
  });
};

let getIndex = (phase: any, subjectName: string) => {
  const subjects = phase.subjects;
  const len = subjects.length;

  if (len >= 1) {
    for (let i = 0; i < len; i++) {
      if (subjects[i].name === subjectName) return i;
    }
  }

  return -1;
};

export default rebuildSubjectsArray;
